<template>
    <div class="min-h-screen font-sans antialiased relative">
      <div class="relative">
   
        <BaseNavbar /> 
        <main class="text-neutral-800">
        <KeepAlive :max="10">
               <slot v-if="$route.meta.keepAlive" :key="$route.name"/>
          </KeepAlive>
          <slot v-if="!$route.meta.keepAlive" />
        </main> 
        <BaseFooter2 />
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'DefaultLayout',
  }
  </script>
  <script setup>
  const { isMobile } = useDevice();
  </script>
  <style>@import "~/assets/css/default.css"; @import "~/assets/css/main.css";</style>
  <style lang="scss">@import "~/assets/css/main.scss";</style>
